/**
 * CWR 1.3 — "Book a Session" card (mockup dashboard-mockup.html:1754–1778).
 *
 * One tap target → the shell's shared `onBook` (resolveBookTarget). The flame
 * ribbon is display:none in the default theme (M1) — depth is the tokenized
 * bloom/ring. The `hero` variant is the Frame-2 empty state.
 */
import type { ReactNode } from 'react';
import { ArrowRightIcon, BookSessionIcon } from './icons';
import styles from '../BookingHubPage.module.css';

export interface BookCardProps {
  variant?: 'default' | 'hero';
  onBook: () => void;
}

export function BookCard({ variant = 'default', onBook }: BookCardProps) {
  const isHero = variant === 'hero';
  const title = isHero ? 'Book your first session' : 'Book a Session';
  const subtitle: ReactNode = (
    <>
      Browse services, classes
      <br />
      &amp; upcoming events
    </>
  );

  return (
    <button
      type="button"
      className={`${styles.bookCard} ${isHero ? styles.bookCardHero : ''}`}
      data-testid="home-book-card"
      onClick={onBook}
      aria-label={title}
    >
      <div className={styles.bookCardInner}>
        <div className={styles.bookIcon}>
          <BookSessionIcon />
        </div>
        <div className={styles.bookText}>
          {isHero && <div className={styles.bookKicker}>Ready when you are</div>}
          <div className={styles.bookTitle}>{title}</div>
          <div className={styles.bookSubtitle}>{subtitle}</div>
        </div>
        <div className={styles.bookArrow} aria-hidden="true">
          <ArrowRightIcon />
        </div>
      </div>
    </button>
  );
}
